<template>
  <div class="content-md">
    <div class="mb-40">{{title}}</div>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <ValidationProvider name="Onay Kodu" rules="required" v-slot="{ errors }">
          <div class="mb-60" :class="{'with-error': errors[0]}">
            <Input id="InputCode" :placeholder="codePlaceHolder" v-model="code" />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
        <ValidationProvider
                name="T.C. Kimlik Numarası"
                rules="required|isTckn"
                v-slot="{ errors }"
                v-if="askForTckn()"
        >
          <div class="mb-60" :class="{'with-error': errors[0]}">
            <Input
                    id="InputEmailTC"
                    placeholder="T.C. Kimlik Numarası"
                    v-model="tckn"
                    maxlength="11"
                    mask="###########"
                    type="tel"
                    @focus="inputFocus"
                    @blur="inputBlur"
            />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>

        <ValidationProvider name="Şifre"
                            rules="required|noStartWithX:0|noWhiteSpaces|min:6|max:20|noRepeatedChars|containsConsecutiveChars"
                            v-slot="{ errors }">
          <div class="mb-60" :class="{'with-error': errors[0]}">
            <Input
              id="InputNewPassword"
              placeholder="Yeni Şifreniz"
              v-model="password"
              type="password"
              @focus="inputFocus"
              @blur="inputBlur"
            />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
        <button id="BtnReset" :disabled="disabled||invalid">Şifreyi Yenile</button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>

    import {mapActions,mapGetters} from "vuex"
    import GeneralUtil from '../../lib/util/generalUtil'

export default {
  name: "ForgotPasswordStep2",
  components: {
    Input: () => import("../../lib/components/Input")
  },
  props: {
    type: {
      type: String,
      default: "phone"
    }
  },
  data: () => ({
    code: "",
    tc: "",
    email: "",
    password: "",
    tckn:""
  }),
  beforeDestroy(){
    this.setPasswordForgotUserInfo("");
  },
  computed: {
    ...mapGetters({
        token:'getPurchaseToken',
        forgotPasswordInfo:'getForgotPasswordInfo',
        forgotPasswordUserInfo:'getForgotPasswordUserInfo',
        quickPayFlow:'getQuickPayFlow'
    }),
    title() {
      return this.forgotPasswordInfo.phoneNumber!=null
        ? "Lütfen telefonunuza gönderilen şifre yenileme kodunu ve yeni şifrenizi girin."
        : "Lütfen e-posta adresinize gönderilen şifre yenileme kodunu ve yeni şifrenizi girin.";
    },
    disabled() {
      return !this.password;
    },
    codePlaceHolder(){
      return this.forgotPasswordInfo.phoneNumber!=null
        ? this.forgotPasswordInfo.phoneNumber+'\'lu telefona gönderilen kod'
        : 'Lütfen E-Posta Onay Kodunu Girin';
    }
  },
  mounted(){
    if (GeneralUtil.isTcknValid(this.forgotPasswordUserInfo)) {
      this.tckn = this.forgotPasswordUserInfo;
    }else{
      this.email = this.forgotPasswordUserInfo;
    }
  },
  methods: {
      ...mapActions({
          forgotPasswordComplete:'forgotPasswordComplete',
          setLoading:'setLoading',
          setPasswordForgotUserInfo:'setPasswordForgotUserInfo',
          setInputFocus:'setInputFocus',
          setInfoPopupText:'setInfoPopupText'
      }),
    inputFocus(){
      this.setInputFocus(true)
    },
    inputBlur(){
      this.setInputFocus(false)
    },
    onSubmit() {
        this.forgotPasswordComplete({userIdentifier:this.forgotPasswordUserInfo, notificationId:this.forgotPasswordInfo.smsId ,tckn:this.tckn ,newPassword:this.password,code:this.code}).then(
            (response)=>{
                //console.log("forgotPasswordComplete-SUCCESS-response:",response);
                this.setInfoPopupText('Şifreniz başarıyla değiştirildi. Yeni şifreniz ile giriş yapabilirsiniz.');
                if(this.quickPayFlow){
                  this.$router.push("/quickpay-login");
                }else {
                  this.$router.push("/login");
                }
            },
            (error)=>{
                //console.log("forgotPasswordComplete-FAIL-response:",error);
                this.setInfoPopupText(error);
                this.setLoading(false);
            }
        );
    },
    askForTckn() {
        return !this.forgotPasswordInfo.tcknNotMandatory && !GeneralUtil.isTcknValid(this.forgotPasswordUserInfo)
    }
  }
};
</script>